module.exports = __webpack_public_path__ + "components/resort-condition/static/conditions-piste-bcc1164b60a803f020c8ceba7711611d.svg";